<div *ngIf="entity == entitiesEnum.Location"
    class="card"
>
    <div class="card-body card-body-profile">
        <logo [alt]="model?.name" [logo]="model?.logo" [size]="'80px'" [style.width]="'80px'" />

        <div class="business-info ms-3">
            <h4>{{ model?.name }}</h4>
            <div>
                {{ model?.address | shortAddress }}
            </div>

            <div class="mt-1 mt-sm-0">
                {{ model?.phoneNumber }}
            </div>
        </div>

        <div class="business-card-actions">
            <button type="button" class="btn btn-outline-primary btn-raise-line btn-xs-borderless"
                *ngxPermissionsOnly="['editLocation']"
                (click)="editClicked($event)"
            >
                <icon-pencil></icon-pencil>
                <span class="d-none d-sm-inline">Edit Location</span>
            </button>

            <!--<button type="button" class="btn btn-danger btn-raise-line btn-xs-borderless"
                *ngxPermissionsOnly="['editBusiness']"
                (click)="deleteClicked($event)"
            >
                <icon-delete></icon-delete>
                <span class="d-none d-sm-inline">Delete</span>
            </button>-->
        </div>
    </div>
</div>

<div *ngIf="entity == entitiesEnum.Business"
    class="card"
>
    <div *ngIf="showMobileHeading" class="card-body d-block d-sm-none pb-0">
        <h5 class="card-title mb-0">Business</h5>
    </div>

    <div class="card-body card-body-profile">
        <logo [alt]="model?.name" [logo]="model?.logo" [size]="'80px'" [style.width]="'80px'" />

        <div class="business-info ms-3">
            <h4>{{ model?.name }}</h4>
            <div>
                Date created:
                <br class="d-sm-none" />
                {{ model?.createdAt | date: 'longDate' }}
            </div>

            <div class="mt-1 mt-sm-0">
                Last updated:
                <br class="d-sm-none" />
                {{ model?.updatedAt | date: 'longDate' }}
            </div>

            <div *ngIf="model?.trialMode" class="mt-1 mt-sm-0">
                Trial ends
                {{ daysTrial() }}
            </div>

            <ng-container *ngIf="showDetails">
            </ng-container>
        </div>

        <div class="business-card-actions">
            <button type="button" class="btn btn-outline-primary btn-raise-line btn-xs-borderless"
                *ngxPermissionsOnly="['editBusiness']"
                (click)="editClicked($event)"
            >
                <icon-pencil />
                <span class="d-none d-sm-inline">Edit Business</span>
            </button>

            <ng-container *ngIf="showDelete">
                <button type="button" class="btn btn-outline-danger btn-raise-line btn-xs-borderless mt-sm-1"
                    *ngxPermissionsOnly="['archiveDeleteBusiness']"
                    (click)="deleteClicked($event)"
                >
                    <icon-delete />
                    <span class="d-none d-sm-inline">Archive</span>
                </button>
            </ng-container>
        </div>
    </div>
</div>

<div *ngIf="entity == entitiesEnum.Reseller"
    class="card"
>
    <div *ngIf="showMobileHeading" class="card-body d-block d-sm-none pb-0">
        <h5 class="card-title mb-0">Reseller</h5>
    </div>

    <div class="card-body card-body-profile">
        <logo [alt]="model?.name" [logo]="model?.logo" [size]="'80px'" [style.width]="'80px'" />

        <div class="business-info ms-3">
            <h4>{{ model?.name }}</h4>
            <div>
                Date created:
                <br class="d-sm-none" />
                {{ model?.createDate | date: 'longDate' }}
            </div>

            <div class="mt-1 mt-sm-0">
                Last updated:
                <br class="d-sm-none" />
                {{ model?.updateDate | date: 'longDate' }}
            </div>

            <ng-container *ngIf="showDetails">
                <div class="mt-1 mt-sm-0">
                    Licenses:

                    <br class="d-sm-none" />

                    {{ model?.availableLicenses }} available

                    <small>
                        ({{ model?.usedLicenses }}
                        /
                        {{ model?.availableLicenses + model?.usedLicenses }})
                    </small>
                </div>
            </ng-container>
        </div>

        <div class="business-card-actions">
            <button type="button" class="btn btn-outline-primary btn-raise-line btn-xs-borderless"
                *ngxPermissionsOnly="['editReseller']"
                (click)="editClicked($event)"
            >
                <icon-pencil></icon-pencil>
                <span class="d-none d-sm-inline">Edit Reseller</span>
            </button>
        </div>
    </div>
</div>

